import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Master} from '../../../../../admin/models/master.interface';
import {FormBuilder, FormControl} from '@angular/forms';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../../utils/filters-utils';
import {MatOption} from '@angular/material/core';

@Component({
  selector: 'app-recycle-chart-filters',
  templateUrl: './recycle-chart-filters.component.html',
  styleUrls: ['./recycle-chart-filters.component.scss']
})
export class RecycleChartFiltersComponent implements OnInit, OnChanges {

  @ViewChild('allSelected') private allSelected!: MatOption;


  @Input()
  years!: number[];
  @Input()
  collectionStreams!: Master[];

  searchForm = this.formBuilder.group({
    year: [''],
    collectionStreams: [''],
    member: [],
    displayUnits: ['AVERAGE'],
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }

  get collectionStreamsControl(): FormControl {
    return this.searchForm.get('collectionStreams') as FormControl;
  }

  get memberControl(): FormControl {
    return this.searchForm.get('member') as FormControl;
  }

  @Output()
  search: EventEmitter<ChartsSearchInterface> = new EventEmitter<ChartsSearchInterface>();

  constructor(private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.yearControl.setValue(this.years[0]);
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.collectionStreams?.length) {
      if (!this.collectionStreamsControl.value || this.collectionStreamsControl.value.length === this.collectionStreams.length) {
        if (this.allSelected) {
          this.allSelected.select();
        }
        this.collectionStreamsControl
          .patchValue([...this.collectionStreams.map(item => item.id.toString()), 0]);
      }
    }
  }

  handleSubmit(): void {
    const search: ChartsSearchInterface = {
      startYear: this.yearControl.value,
      categories: this.collectionStreamsControl.value,
      member: this.memberControl.value,
      displayUnits: this.searchForm.controls.displayUnits.value
    };
    this.search.emit(search);
    if (this.collectionStreamsControl.value.length >= this.collectionStreams.length) {
      this.allSelected.select();
    }
  }

  clean(): void {
    this.yearControl.setValue(this.years[this.years.length - 1]);
    this.searchForm.controls.displayUnits.setValue('AVERAGE');
    this.collectionStreamsControl.reset();
    this.memberControl.reset();
    this.search.emit({startYear: this.years[0], displayUnits: 'AVERAGE'});
  }

  togglePerOne(): void {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return;
    }
    if (this.collectionStreamsControl.value.length === this.collectionStreams.length) {
      this.allSelected.select();
    }
  }

  toggleAllSelection(): void {
    if (this.allSelected.selected) {
      this.collectionStreamsControl
        .patchValue([...this.collectionStreams.map(item => item.id.toString()), 0]);
    } else {
      this.collectionStreamsControl.patchValue([]);
    }
  }
}
